import { get } from '../api.service';

export interface UserDashboardParams {
  PageNumber: number;
  PageSize: number;
  DateTime?: string;
  type?: number;
  status?: number;
}

export interface InvoiceItem {
  id: number;
  invoiceNumber: number;
  clientName: string;
  amount: number;
  dueDate: string;
  invoiceStatus: number;
  paymentTerm?: string;
  accountType?: number;
  country?: string;
  stage?: string;
  customer?: {
    name?: string;
    paymentTerm?: string;
    accountType?: number;
    country?: string;
  };
  currency: string;
}

export interface UserDashboardResponse {
  statusCode: number;
  message: string;
  response: InvoiceItem[];
  totalCount: number;
  numberOfPages: number;
}

/**
 * Fetches user dashboard data with pagination and filters.
 * @param params - The request parameters containing PageNumber, PageSize, type (stage), and status.
 * @returns The API response with the paginated user dashboard data.
 */
export const fetchUserDashboard = async (params: UserDashboardParams): Promise<UserDashboardResponse> => {
    return await get('/invoicev2/get-all-invoice-v2', {
      PageNumber: params.PageNumber,
      PageSize: params.PageSize,
      ...(params.type && { type: params.type }),
      ...(params.status && { status: params.status }),
    });
};

/**
 * Fetches user dashboard data with custom parameters.
 * @param params - Custom parameters for the dashboard API.
 * @returns The API response with the user dashboard data.
 */
export const fetchUserDashboardWithParams = async (params: Record<string, any>): Promise<UserDashboardResponse> => {
    return await get('/invoicev2/get-all-invoice-v2', params);
};

/**
 * Fetches user dashboard data filtered by DateTime.
 * @param params - The request parameters containing PageNumber, PageSize, and DateTime.
 * @returns The API response with the paginated user dashboard data.
 */
export const fetchUserDashboardByDate = async (params: UserDashboardParams): Promise<UserDashboardResponse> => {
    return await get('userdashboard', {
      PageNumber: params.PageNumber,
      PageSize: params.PageSize,
      ...(params.DateTime && { DateTime: params.DateTime }),
      ...(params.type && { type: params.type }),
      ...(params.status && { status: params.status }),
    });
};